import { Box, Grid, Typography } from '@mui/material';
import { DetailRow } from './DetailRow';

interface ProductDetailsData {
    licenseQuantity?: string | number | null;
    supportCost?: number | null;
    totalLabor?: number | null;
    totalHardwareCost?: number | null;
    totalSoftwareCost?: number | null;
    overallCost?: number | null;
}

interface CostDetailsCardProps {
    data: ProductDetailsData | null;
}

const CostDetailsCard = ({ data }: CostDetailsCardProps) => {
    if (!data) return null;

    const getPerLicenseCost = () => {
        const quantity = typeof data.licenseQuantity === 'number' ? data.licenseQuantity : Number(data.licenseQuantity);
        if (data.overallCost == null || data.licenseQuantity == null || Number.isNaN(quantity) || quantity === 0) {
            return '-';
        }
        return `$${(data.overallCost / quantity).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
    };

    const formatCost = (value: number | null | undefined) => {
        return typeof value === 'number' ? `$${value.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}` : '-';
    };

    const columnFields = [
        { label: 'Per License Cost', value: getPerLicenseCost() },
        { label: 'Software Cost', value: formatCost(data.totalSoftwareCost) },
        { label: 'Hardware Cost', value: formatCost(data.totalHardwareCost) },
        { label: 'Labor Cost', value: formatCost(data.totalLabor) },
        { label: 'Support Cost', value: formatCost(data.supportCost) },
        { label: 'Total Cost', value: formatCost(data.overallCost) }
    ];

    return (
        <Box
            sx={{
                background: '#ffffff',
                borderRadius: '8px',
                p: 3,
				height: 'calc(100% - 48px)'
            }}
        >
            <Typography
                sx={{
                    fontSize: '18px',
                    fontWeight: 700,
                    color: '#1b1f23',
                    mb: 2,
                    pb: 1,
                }}
            >
                Cost
            </Typography>
            <Grid container spacing={3}>
                <Grid item xs={12}>
                    {columnFields.map((field) => (
                        <DetailRow key={field.label} label={field.label} value={field.value} />
                    ))}
                </Grid>
            </Grid>
        </Box>
    );
};

export default CostDetailsCard;
